module.exports = __webpack_public_path__ + "img/item-info-icon5.063d1b57.svg";